<div class="card flex justify-content-center">
  <div class="dialog-content">
    <form>
      <div style="word-wrap: break-word;padding-top: 20px;">
        <p>{{termsStatusToShow}}</p>
      </div>
      <div class="row" style="padding-top: 30px;">
        <div style="width: 100%;">
          <span class="col-sm-12">
            <input id="termsAccepted" type="checkbox"  (change)="termsAcceptedOrRejected($event)">
            <span class="terms-accept-text">
              Jeg accepterer herved
              <span class="pseudolink" (click)="showTermsDialog()">vilkår og betingelser</span> 
              ved indsamling af personoplysninger.
            </span>
          </span>
        </div>
      </div>
      <ng-container *ngIf="enableRejectReason" class="hidenContent">
        <div class="row" style="padding-top: 30px;">
          <div style="width: 100%;text-align: center;">
            <span class="col-sm-12">
              Da vilkår og registreringspraksis ikke er blevet accepteret,<br/>
            </span>
            <span class="col-sm-12">
              vil adgangen til de ønskede komponenter ikke kunne gennemføres.
            </span>
          </div>
        </div>
      </ng-container>
      <div class="p-dialog-footer">
        <div class="button-container">
          <button pButton class="p-button" [disabled]="isAfviseEnable" (click)="onReject($event)">Afvis</button>
          <button pButton class="p-button" [disabled]="isGemEnable" (click)="onSave($event)">Gem</button>
        </div>
      </div>
    </form>
  </div>
</div>